import { SVGProps } from 'react';

export const Logout = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.3536 7.64645C14.5488 7.84171 14.5488 8.15829 14.3536 8.35355L11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536C10.4512 11.1583 10.4512 10.8417 10.6464 10.6464L12.7929 8.5L5 8.5C4.72386 8.5 4.5 8.27614 4.5 8C4.5 7.72386 4.72386 7.5 5 7.5L12.7929 7.5L10.6464 5.35355C10.4512 5.15829 10.4512 4.84171 10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645L14.3536 7.64645ZM5.5 2C5.5 2.27614 5.27614 2.5 5 2.5L3.5 2.5C2.94772 2.5 2.5 2.94771 2.5 3.5L2.5 12.5C2.5 13.0523 2.94771 13.5 3.5 13.5L5 13.5C5.27614 13.5 5.5 13.7239 5.5 14C5.5 14.2761 5.27614 14.5 5 14.5L3.5 14.5C2.39543 14.5 1.5 13.6046 1.5 12.5L1.5 3.5C1.5 2.39543 2.39543 1.5 3.5 1.5L5 1.5C5.27614 1.5 5.5 1.72386 5.5 2Z'
    />
  </svg>
);
